/**
 * [CCI-18182] Diff-based segmenting — eligibility check.
 *
 * Whether the Post Stream Review ("Review moment") splits a top-level change into
 * finer diff-level sub-segments (`diffSegments`) instead of segmenting at the
 * top-level node boundary only.
 *
 * Driven by the `'review-moment-diff-based-segmenting'` token of
 * `platform_editor_ai_streaming_ux_m1_config`, AND-gated with the M1 master
 * experiment so the slice stays inside the M1 cohort. [CCI-19338]
 */
import { isReviewMomentDiffBasedSegmentingEnabled } from '../../pm-plugins/ai-session-context/review-moment-config';

import { isStreamingUxExperienceM1EnabledNoExposure } from './streaming-ux-experience-m1-enabled';

/**
 * Returns true when diff-based segmenting is enabled for the current user.
 *
 * This is the **non-exposure-logging** variant: every call site lives on the
 * Review-moment render / read path, so the canonical M1 exposure is already
 * logged by the Review moment gate-enforcement points.
 */
export function isDiffBasedSegmentingEnabled(): boolean {
	return isReviewMomentDiffBasedSegmentingEnabled() && isStreamingUxExperienceM1EnabledNoExposure();
}
